import React, { useEffect, useState } from 'react'
import InlineIcon from '../InlineIcon/InlineIcon.jsx'
import './Connection.scss'

const Connection = () => {
  const [online, setOnline] = useState(true)

  useEffect(() => {
    const goOffline = () => {
      setOnline(false)
    }
    const goOnline = () => {
      setOnline(true)
    }

    window.addEventListener('offline', goOffline)
    window.addEventListener('online', goOnline)

    return () => {
      window.removeEventListener('offline', goOffline)
      window.removeEventListener('online', goOnline)
    }
  }, [])

  if (online) return null

  return (
    <div className='connection-lost' role='alert'>
      <InlineIcon name='alert-triangle' className='connection-lost__icon' />
      No internet connection detected. Please connect to the internet before
      attempting to access the app.
    </div>
  )
}

export default Connection
